import { useParams, Link, Navigate } from "react-router-dom";
import content from "../../data/content";
import CtaBanner from "../../components/CtaBanner";
import "./CourseDetail.css";

const { courses } = content;

export default function CourseDetail() {
  const { slug } = useParams();
  const course = courses.courseList.items.find((c) => c.slug === slug);

  if (!course) return <Navigate to="/courses" replace />;

  return (
    <div className="course-detail">
      <section className="course-detail__header">
        <Link to="/courses" className="course-detail__back">← 返回課程列表</Link>
        <h1 className="course-detail__title">{course.name}</h1>
      </section>

      <section className="course-detail__body">
        <div className="course-detail__inner">
          {course.description && (
            <p className="course-detail__desc">{course.description}</p>
          )}

          {course.details && (
            <div className="course-detail__details">
              <p className="course-detail__focus-label">本課程著重於：</p>
              <ul className="course-detail__focus-list">
                {course.details.focus.map((f, j) => (
                  <li key={j}>{f}</li>
                ))}
              </ul>
              <p className="course-detail__suitable">
                {course.details.suitableFor}
              </p>
            </div>
          )}

          {course.includes && (
            <div className="course-detail__includes">
              <p className="course-detail__includes-label">包含內容：</p>
              {course.includes.map((inc, j) => (
                <div key={j} className="course-detail__include-item">
                  <h3>{inc.name}</h3>
                  <p>{inc.description}</p>
                </div>
              ))}
            </div>
          )}

          {/* ---- Photo Gallery ---- */}
          {course.images && (
            <div className="course-detail__gallery">
              <h2 className="course-detail__gallery-heading">課程照片</h2>
              <div className="course-detail__gallery-grid">
                {course.images.map((src, i) => (
                  <div key={i} className="course-detail__gallery-item">
                    <img
                      src={src}
                      alt={`${course.name} ${i + 1}`}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div className="img-placeholder" style={{ display: "none" }}>
                      Photo {i + 1}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
